import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "ng/src/app/shared/shared.module";
import { LogUserGroupListSelectorComponent } from "ng/src/app/users/logbook-user-group-list-selector/log-user-group-list-selector.component";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LogbookUserSelectorComponent } from "ng/src/app/users/logbook-user-selector.component";
import { AutoCompleteModule } from "primeng/autocomplete";
import { LogbookUserListSelectorComponent } from "ng/src/app/users/logbook-user-list-selector.component/logbook-user-list-selector.component";
import { ListboxModule } from "primeng/listbox";

@NgModule({
	declarations: [
		LogbookUserSelectorComponent,
		LogbookUserListSelectorComponent,
		LogUserGroupListSelectorComponent
	],
	exports: [
		LogbookUserSelectorComponent,
		LogbookUserListSelectorComponent,
		LogUserGroupListSelectorComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		DropdownModule,
		ReactiveFormsModule,
		AutoCompleteModule,
		ListboxModule,
		SharedModule
	]
})
export class UsersModule {}